import { render, staticRenderFns } from "./RecalcularDas.vue?vue&type=template&id=61d4fb24&"
import script from "./RecalcularDas.vue?vue&type=script&lang=js&"
export * from "./RecalcularDas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports